import BACK_HAIR_0_URL from './backHair/4x/backHair-0.png';
import BACK_HAIR_1_URL from './backHair/4x/backHair-1.png';
import BACK_HAIR_2_URL from './backHair/4x/backHair-2.png';
import BACK_HAIR_3_URL from './backHair/4x/backHair-3.png';
import BACK_HAIR_4_URL from './backHair/4x/backHair-4.png';
import BACK_HAIR_5_URL from './backHair/4x/backHair-5.png';
import BACK_HAIR_6_URL from './backHair/4x/backHair-6.png';
import BACK_HAIR_7_URL from './backHair/4x/backHair-7.png';
import BACK_HAIR_8_URL from './backHair/4x/backHair-8.png';
import BACK_HAIR_9_URL from './backHair/4x/backHair-9.png';
import BACK_HAIR_10_URL from './backHair/4x/backHair-10.png';
import BACK_HAIR_11_URL from './backHair/4x/backHair-11.png';
import BACK_HAIR_12_URL from './backHair/4x/backHair-12.png';
import BACK_HAIR_13_URL from './backHair/4x/backHair-13.png';
import BACK_HAIR_14_URL from './backHair/4x/backHair-14.png';
import BACK_HAIR_15_URL from './backHair/4x/backHair-15.png';
import BACK_HAIR_16_URL from './backHair/4x/backHair-16.png';
import BACK_HAIR_17_URL from './backHair/4x/backHair-17.png';
import BACK_HAIR_18_URL from './backHair/4x/backHair-18.png';
import BACK_HAIR_19_URL from './backHair/4x/backHair-19.png';
import BACK_HAIR_20_URL from './backHair/4x/backHair-20.png';
import BACK_HAIR_21_URL from './backHair/4x/backHair-21.png';
import BACK_HAIR_22_URL from './backHair/4x/backHair-22.png';
import BACK_HAIR_23_URL from './backHair/4x/backHair-23.png';
import BACK_HAIR_24_URL from './backHair/4x/backHair-24.png';
import BACK_HAIR_25_URL from './backHair/4x/backHair-25.png';
import BACK_HAIR_26_URL from './backHair/4x/backHair-26.png';
import BACK_HAIR_27_URL from './backHair/4x/backHair-27.png';
import BACK_HAIR_28_URL from './backHair/4x/backHair-28.png';
import BACK_HAIR_29_URL from './backHair/4x/backHair-29.png';
import BACK_HAIR_30_URL from './backHair/4x/backHair-30.png';
import BACK_HAIR_31_URL from './backHair/4x/backHair-31.png';
import BACK_HAIR_32_URL from './backHair/4x/backHair-32.png';
import BACK_HAIR_33_URL from './backHair/4x/backHair-33.png';
import BACK_HAIR_34_URL from './backHair/4x/backHair-34.png';
import BACK_HAIR_35_URL from './backHair/4x/backHair-35.png';
import BACK_HAIR_36_URL from './backHair/4x/backHair-36.png';
import BACK_HAIR_37_URL from './backHair/4x/backHair-37.png';
import BACK_HAIR_38_URL from './backHair/4x/backHair-38.png';
import BACK_HAIR_39_URL from './backHair/4x/backHair-39.png';
import BACK_HAIR_40_URL from './backHair/4x/backHair-40.png';
import BACK_HAIR_41_URL from './backHair/4x/backHair-41.png';
import BACK_HAIR_42_URL from './backHair/4x/backHair-42.png';
import BACK_HAIR_43_URL from './backHair/4x/backHair-43.png';
import BACK_HAIR_44_URL from './backHair/4x/backHair-44.png';
import BACK_HAIR_45_URL from './backHair/4x/backHair-45.png';
import EARS_0_URL from './ears/4x/ears-0.png';
import EARS_1_URL from './ears/4x/ears-1.png';
import EARS_2_URL from './ears/4x/ears-2.png';
import EARS_3_URL from './ears/4x/ears-3.png';
import EARS_4_URL from './ears/4x/ears-4.png';
import EARS_5_URL from './ears/4x/ears-5.png';
import EARS_6_URL from './ears/4x/ears-6.png';
import EARS_7_URL from './ears/4x/ears-7.png';
import EARS_8_URL from './ears/4x/ears-8.png';
import EARS_9_URL from './ears/4x/ears-9.png';
import EARS_10_URL from './ears/4x/ears-10.png';
import EARS_11_URL from './ears/4x/ears-11.png';
import EARS_12_URL from './ears/4x/ears-12.png';
import EARS_13_URL from './ears/4x/ears-13.png';
import EARS_14_URL from './ears/4x/ears-14.png';
import EARS_15_URL from './ears/4x/ears-15.png';
import EARS_16_URL from './ears/4x/ears-16.png';
import EARS_17_URL from './ears/4x/ears-17.png';
import EYEBROWS_0_URL from './eyebrows/4x/eyebrows-0.png';
import EYEBROWS_1_URL from './eyebrows/4x/eyebrows-1.png';
import EYEBROWS_2_URL from './eyebrows/4x/eyebrows-2.png';
import EYEBROWS_3_URL from './eyebrows/4x/eyebrows-3.png';
import EYEBROWS_4_URL from './eyebrows/4x/eyebrows-4.png';
import EYEBROWS_5_URL from './eyebrows/4x/eyebrows-5.png';
import EYEBROWS_6_URL from './eyebrows/4x/eyebrows-6.png';
import EYEBROWS_7_URL from './eyebrows/4x/eyebrows-7.png';
import EYEBROWS_8_URL from './eyebrows/4x/eyebrows-8.png';
import EYEBROWS_9_URL from './eyebrows/4x/eyebrows-9.png';
import EYEBROWS_10_URL from './eyebrows/4x/eyebrows-10.png';
import EYEBROWS_11_URL from './eyebrows/4x/eyebrows-11.png';
import EYEBROWS_12_URL from './eyebrows/4x/eyebrows-12.png';
import EYEBROWS_13_URL from './eyebrows/4x/eyebrows-13.png';
import EYEBROWS_14_URL from './eyebrows/4x/eyebrows-14.png';
import EYEBROWS_15_URL from './eyebrows/4x/eyebrows-15.png';
import EYEBROWS_16_URL from './eyebrows/4x/eyebrows-16.png';
import EYEBROWS_17_URL from './eyebrows/4x/eyebrows-17.png';
import EYEBROWS_18_URL from './eyebrows/4x/eyebrows-18.png';
import EYEBROWS_19_URL from './eyebrows/4x/eyebrows-19.png';
import EYEBROWS_20_URL from './eyebrows/4x/eyebrows-20.png';
import EYEBROWS_21_URL from './eyebrows/4x/eyebrows-21.png';
import EYEBROWS_22_URL from './eyebrows/4x/eyebrows-22.png';
import EYEBROWS_23_URL from './eyebrows/4x/eyebrows-23.png';
import EYEBROWS_24_URL from './eyebrows/4x/eyebrows-24.png';
import EYEBROWS_25_URL from './eyebrows/4x/eyebrows-25.png';
import EYEBROWS_26_URL from './eyebrows/4x/eyebrows-26.png';
import EYEBROWS_27_URL from './eyebrows/4x/eyebrows-27.png';
import EYEBROWS_28_URL from './eyebrows/4x/eyebrows-28.png';
import EYEBROWS_29_URL from './eyebrows/4x/eyebrows-29.png';
import EYEBROWS_30_URL from './eyebrows/4x/eyebrows-30.png';
import EYEBROWS_31_URL from './eyebrows/4x/eyebrows-31.png';
import EYEBROWS_32_URL from './eyebrows/4x/eyebrows-32.png';
import EYEBROWS_33_URL from './eyebrows/4x/eyebrows-33.png';
import EYEBROWS_34_URL from './eyebrows/4x/eyebrows-34.png';
import EYEBROWS_35_URL from './eyebrows/4x/eyebrows-35.png';
import EYEBROWS_36_URL from './eyebrows/4x/eyebrows-36.png';
import EYEBROWS_37_URL from './eyebrows/4x/eyebrows-37.png';
import EYEBROWS_38_URL from './eyebrows/4x/eyebrows-38.png';
import EYEBROWS_39_URL from './eyebrows/4x/eyebrows-39.png';
import EYEBROWS_40_URL from './eyebrows/4x/eyebrows-40.png';
import EYEBROWS_41_URL from './eyebrows/4x/eyebrows-41.png';
import EYEBROWS_42_URL from './eyebrows/4x/eyebrows-42.png';
import EYEBROWS_43_URL from './eyebrows/4x/eyebrows-43.png';
import EYEBROWS_44_URL from './eyebrows/4x/eyebrows-44.png';
import EYEBROWS_45_URL from './eyebrows/4x/eyebrows-45.png';
import EYEBROWS_46_URL from './eyebrows/4x/eyebrows-46.png';
import EYEBROWS_47_URL from './eyebrows/4x/eyebrows-47.png';
import EYES_0_URL from './eyes/4x/eyes-0.png';
import EYES_1_URL from './eyes/4x/eyes-1.png';
import EYES_2_URL from './eyes/4x/eyes-2.png';
import EYES_3_URL from './eyes/4x/eyes-3.png';
import EYES_4_URL from './eyes/4x/eyes-4.png';
import EYES_5_URL from './eyes/4x/eyes-5.png';
import EYES_6_URL from './eyes/4x/eyes-6.png';
import EYES_7_URL from './eyes/4x/eyes-7.png';
import EYES_8_URL from './eyes/4x/eyes-8.png';
import EYES_9_URL from './eyes/4x/eyes-9.png';
import EYES_10_URL from './eyes/4x/eyes-10.png';
import EYES_11_URL from './eyes/4x/eyes-11.png';
import EYES_12_URL from './eyes/4x/eyes-12.png';
import EYES_13_URL from './eyes/4x/eyes-13.png';
import EYES_14_URL from './eyes/4x/eyes-14.png';
import EYES_15_URL from './eyes/4x/eyes-15.png';
import EYES_16_URL from './eyes/4x/eyes-16.png';
import EYES_17_URL from './eyes/4x/eyes-17.png';
import EYES_18_URL from './eyes/4x/eyes-18.png';
import EYES_19_URL from './eyes/4x/eyes-19.png';
import EYES_20_URL from './eyes/4x/eyes-20.png';
import EYEWEAR_0_URL from './eyewear/4x/eyewear-0.png';
import EYEWEAR_1_URL from './eyewear/4x/eyewear-1.png';
import EYEWEAR_2_URL from './eyewear/4x/eyewear-2.png';
import EYEWEAR_3_URL from './eyewear/4x/eyewear-3.png';
import EYEWEAR_4_URL from './eyewear/4x/eyewear-4.png';
import EYEWEAR_5_URL from './eyewear/4x/eyewear-5.png';
import EYEWEAR_6_URL from './eyewear/4x/eyewear-6.png';
import EYEWEAR_7_URL from './eyewear/4x/eyewear-7.png';
import EYEWEAR_8_URL from './eyewear/4x/eyewear-8.png';
import EYEWEAR_9_URL from './eyewear/4x/eyewear-9.png';
import EYEWEAR_10_URL from './eyewear/4x/eyewear-10.png';
import EYEWEAR_11_URL from './eyewear/4x/eyewear-11.png';
import EYEWEAR_12_URL from './eyewear/4x/eyewear-12.png';
import EYEWEAR_13_URL from './eyewear/4x/eyewear-13.png';
import EYEWEAR_14_URL from './eyewear/4x/eyewear-14.png';
import EYEWEAR_15_URL from './eyewear/4x/eyewear-15.png';
import EYEWEAR_16_URL from './eyewear/4x/eyewear-16.png';
import EYEWEAR_17_URL from './eyewear/4x/eyewear-17.png';
import EYEWEAR_18_URL from './eyewear/4x/eyewear-18.png';
import EYEWEAR_19_URL from './eyewear/4x/eyewear-19.png';
import FACIAL_HAIR_0_URL from './facialHair/4x/facialHair-0.png';
import FACIAL_HAIR_1_URL from './facialHair/4x/facialHair-1.png';
import FACIAL_HAIR_2_URL from './facialHair/4x/facialHair-2.png';
import FACIAL_HAIR_3_URL from './facialHair/4x/facialHair-3.png';
import FACIAL_HAIR_4_URL from './facialHair/4x/facialHair-4.png';
import FACIAL_HAIR_5_URL from './facialHair/4x/facialHair-5.png';
import FACIAL_HAIR_6_URL from './facialHair/4x/facialHair-6.png';
import FACIAL_HAIR_7_URL from './facialHair/4x/facialHair-7.png';
import FACIAL_HAIR_8_URL from './facialHair/4x/facialHair-8.png';
import FACIAL_HAIR_9_URL from './facialHair/4x/facialHair-9.png';
import FACIAL_HAIR_10_URL from './facialHair/4x/facialHair-10.png';
import FACIAL_HAIR_11_URL from './facialHair/4x/facialHair-11.png';
import FACIAL_HAIR_12_URL from './facialHair/4x/facialHair-12.png';
import FACIAL_HAIR_13_URL from './facialHair/4x/facialHair-13.png';
import FACIAL_HAIR_14_URL from './facialHair/4x/facialHair-14.png';
import FACIAL_HAIR_15_URL from './facialHair/4x/facialHair-15.png';
import FACIAL_HAIR_16_URL from './facialHair/4x/facialHair-16.png';
import FACIAL_HAIR_17_URL from './facialHair/4x/facialHair-17.png';
import FACIAL_HAIR_18_URL from './facialHair/4x/facialHair-18.png';
import FACIAL_HAIR_19_URL from './facialHair/4x/facialHair-19.png';
import FACIAL_HAIR_20_URL from './facialHair/4x/facialHair-20.png';
import FACIAL_HAIR_21_URL from './facialHair/4x/facialHair-21.png';
import FACIAL_HAIR_22_URL from './facialHair/4x/facialHair-22.png';
import FACIAL_HAIR_23_URL from './facialHair/4x/facialHair-23.png';
import FACIAL_HAIR_24_URL from './facialHair/4x/facialHair-24.png';
import FACIAL_HAIR_25_URL from './facialHair/4x/facialHair-25.png';
import FACIAL_HAIR_26_URL from './facialHair/4x/facialHair-26.png';
import FACIAL_HAIR_27_URL from './facialHair/4x/facialHair-27.png';
import FACIAL_HAIR_28_URL from './facialHair/4x/facialHair-28.png';
import FACIAL_HAIR_29_URL from './facialHair/4x/facialHair-29.png';
import FACIAL_HAIR_30_URL from './facialHair/4x/facialHair-30.png';
import FACIAL_HAIR_31_URL from './facialHair/4x/facialHair-31.png';
import FACIAL_HAIR_32_URL from './facialHair/4x/facialHair-32.png';
import FACIAL_HAIR_33_URL from './facialHair/4x/facialHair-33.png';
import FACIAL_HAIR_34_URL from './facialHair/4x/facialHair-34.png';
import FACIAL_HAIR_35_URL from './facialHair/4x/facialHair-35.png';
import FACIAL_HAIR_36_URL from './facialHair/4x/facialHair-36.png';
import FACIAL_HAIR_37_URL from './facialHair/4x/facialHair-37.png';
import FACIAL_HAIR_38_URL from './facialHair/4x/facialHair-38.png';
import FACIAL_HAIR_39_URL from './facialHair/4x/facialHair-39.png';
import FACIAL_HAIR_40_URL from './facialHair/4x/facialHair-40.png';
import FACIAL_HAIR_41_URL from './facialHair/4x/facialHair-41.png';
import FACIAL_HAIR_42_URL from './facialHair/4x/facialHair-42.png';
import FACIAL_HAIR_43_URL from './facialHair/4x/facialHair-43.png';
import FACIAL_HAIR_44_URL from './facialHair/4x/facialHair-44.png';
import FACIAL_HAIR_45_URL from './facialHair/4x/facialHair-45.png';
import FACIAL_HAIR_46_URL from './facialHair/4x/facialHair-46.png';
import FACIAL_HAIR_47_URL from './facialHair/4x/facialHair-47.png';
import FACIAL_HAIR_48_URL from './facialHair/4x/facialHair-48.png';
import FACIAL_HAIR_49_URL from './facialHair/4x/facialHair-49.png';
import FACIAL_HAIR_50_URL from './facialHair/4x/facialHair-50.png';
import FACIAL_HAIR_51_URL from './facialHair/4x/facialHair-51.png';
import FACIAL_HAIR_52_URL from './facialHair/4x/facialHair-52.png';
import FACIAL_HAIR_53_URL from './facialHair/4x/facialHair-53.png';
import FACIAL_HAIR_54_URL from './facialHair/4x/facialHair-54.png';
import FACIAL_LINES_0_URL from './facialLines/4x/facialLines-0.png';
import FACIAL_LINES_1_URL from './facialLines/4x/facialLines-1.png';
import FACIAL_LINES_2_URL from './facialLines/4x/facialLines-2.png';
import FACIAL_LINES_3_URL from './facialLines/4x/facialLines-3.png';
import FACIAL_LINES_4_URL from './facialLines/4x/facialLines-4.png';
import FACIAL_LINES_5_URL from './facialLines/4x/facialLines-5.png';
import FACIAL_LINES_6_URL from './facialLines/4x/facialLines-6.png';
import FACIAL_LINES_7_URL from './facialLines/4x/facialLines-7.png';
import FACIAL_LINES_8_URL from './facialLines/4x/facialLines-8.png';
import FACIAL_LINES_9_URL from './facialLines/4x/facialLines-9.png';
import FACIAL_LINES_10_URL from './facialLines/4x/facialLines-10.png';
import FACIAL_LINES_11_URL from './facialLines/4x/facialLines-11.png';
import FACIAL_LINES_12_URL from './facialLines/4x/facialLines-12.png';
import FACIAL_LINES_13_URL from './facialLines/4x/facialLines-13.png';
import FACIAL_LINES_14_URL from './facialLines/4x/facialLines-14.png';
import FACIAL_LINES_15_URL from './facialLines/4x/facialLines-15.png';
import FACIAL_LINES_16_URL from './facialLines/4x/facialLines-16.png';
import FACIAL_LINES_17_URL from './facialLines/4x/facialLines-17.png';
import FACIAL_LINES_18_URL from './facialLines/4x/facialLines-18.png';
import FACIAL_LINES_19_URL from './facialLines/4x/facialLines-19.png';
import FACIAL_LINES_20_URL from './facialLines/4x/facialLines-20.png';
import FACIAL_LINES_21_URL from './facialLines/4x/facialLines-21.png';
import FACIAL_LINES_22_URL from './facialLines/4x/facialLines-22.png';
import FACIAL_LINES_23_URL from './facialLines/4x/facialLines-23.png';
import FACIAL_LINES_24_URL from './facialLines/4x/facialLines-24.png';
import FACIAL_LINES_25_URL from './facialLines/4x/facialLines-25.png';
import FACIAL_LINES_26_URL from './facialLines/4x/facialLines-26.png';
import FACIAL_LINES_27_URL from './facialLines/4x/facialLines-27.png';
import FACIAL_LINES_28_URL from './facialLines/4x/facialLines-28.png';
import FACIAL_LINES_29_URL from './facialLines/4x/facialLines-29.png';
import FACIAL_LINES_30_URL from './facialLines/4x/facialLines-30.png';
import FACIAL_LINES_31_URL from './facialLines/4x/facialLines-31.png';
import FACIAL_LINES_32_URL from './facialLines/4x/facialLines-32.png';
import FACIAL_LINES_33_URL from './facialLines/4x/facialLines-33.png';
import FACIAL_LINES_34_URL from './facialLines/4x/facialLines-34.png';
import FACIAL_LINES_35_URL from './facialLines/4x/facialLines-35.png';
import FACIAL_LINES_36_URL from './facialLines/4x/facialLines-36.png';
import FACIAL_LINES_37_URL from './facialLines/4x/facialLines-37.png';
import FACIAL_LINES_38_URL from './facialLines/4x/facialLines-38.png';
import FACIAL_LINES_39_URL from './facialLines/4x/facialLines-39.png';
import FACIAL_LINES_40_URL from './facialLines/4x/facialLines-40.png';
import FACIAL_LINES_41_URL from './facialLines/4x/facialLines-41.png';
import FACIAL_LINES_42_URL from './facialLines/4x/facialLines-42.png';
import FACIAL_LINES_43_URL from './facialLines/4x/facialLines-43.png';
import FACIAL_LINES_44_URL from './facialLines/4x/facialLines-44.png';
import FACIAL_LINES_45_URL from './facialLines/4x/facialLines-45.png';
import FACIAL_LINES_46_URL from './facialLines/4x/facialLines-46.png';
import FACIAL_LINES_47_URL from './facialLines/4x/facialLines-47.png';
import FACIAL_LINES_48_URL from './facialLines/4x/facialLines-48.png';
import HAIR_0_URL from './hair/4x/hair-0.png';
import HAIR_1_URL from './hair/4x/hair-1.png';
import HAIR_2_URL from './hair/4x/hair-2.png';
import HAIR_3_URL from './hair/4x/hair-3.png';
import HAIR_4_URL from './hair/4x/hair-4.png';
import HAIR_5_URL from './hair/4x/hair-5.png';
import HAIR_6_URL from './hair/4x/hair-6.png';
import HAIR_7_URL from './hair/4x/hair-7.png';
import HAIR_8_URL from './hair/4x/hair-8.png';
import HAIR_9_URL from './hair/4x/hair-9.png';
import HAIR_10_URL from './hair/4x/hair-10.png';
import HAIR_11_URL from './hair/4x/hair-11.png';
import HAIR_12_URL from './hair/4x/hair-12.png';
import HAIR_13_URL from './hair/4x/hair-13.png';
import HAIR_14_URL from './hair/4x/hair-14.png';
import HAIR_15_URL from './hair/4x/hair-15.png';
import HAIR_16_URL from './hair/4x/hair-16.png';
import HAIR_17_URL from './hair/4x/hair-17.png';
import HAIR_18_URL from './hair/4x/hair-18.png';
import HAIR_19_URL from './hair/4x/hair-19.png';
import HAIR_20_URL from './hair/4x/hair-20.png';
import HAIR_21_URL from './hair/4x/hair-21.png';
import HAIR_22_URL from './hair/4x/hair-22.png';
import HAIR_23_URL from './hair/4x/hair-23.png';
import HAIR_24_URL from './hair/4x/hair-24.png';
import HAIR_25_URL from './hair/4x/hair-25.png';
import HAIR_26_URL from './hair/4x/hair-26.png';
import HAIR_27_URL from './hair/4x/hair-27.png';
import HAIR_28_URL from './hair/4x/hair-28.png';
import HAIR_29_URL from './hair/4x/hair-29.png';
import HAIR_30_URL from './hair/4x/hair-30.png';
import HAIR_31_URL from './hair/4x/hair-31.png';
import HAIR_32_URL from './hair/4x/hair-32.png';
import HAIR_33_URL from './hair/4x/hair-33.png';
import HAIR_34_URL from './hair/4x/hair-34.png';
import HAIR_35_URL from './hair/4x/hair-35.png';
import HAIR_36_URL from './hair/4x/hair-36.png';
import HAIR_37_URL from './hair/4x/hair-37.png';
import HAIR_38_URL from './hair/4x/hair-38.png';
import HAIR_39_URL from './hair/4x/hair-39.png';
import HAIR_40_URL from './hair/4x/hair-40.png';
import HAIR_41_URL from './hair/4x/hair-41.png';
import HAIR_42_URL from './hair/4x/hair-42.png';
import HAIR_43_URL from './hair/4x/hair-43.png';
import HAIR_44_URL from './hair/4x/hair-44.png';
import HAIR_45_URL from './hair/4x/hair-45.png';
import HAIR_46_URL from './hair/4x/hair-46.png';
import HAIR_47_URL from './hair/4x/hair-47.png';
import HAIR_48_URL from './hair/4x/hair-48.png';
import HAIR_49_URL from './hair/4x/hair-49.png';
import HAIR_50_URL from './hair/4x/hair-50.png';
import HAIR_51_URL from './hair/4x/hair-51.png';
import HAIR_52_URL from './hair/4x/hair-52.png';
import HAIR_53_URL from './hair/4x/hair-53.png';
import HAIR_54_URL from './hair/4x/hair-54.png';
import HAIR_55_URL from './hair/4x/hair-55.png';
import HAIR_56_URL from './hair/4x/hair-56.png';
import HAIR_57_URL from './hair/4x/hair-57.png';
import HAIR_58_URL from './hair/4x/hair-58.png';
import HAIR_59_URL from './hair/4x/hair-59.png';
import HAIR_60_URL from './hair/4x/hair-60.png';
import HAIR_61_URL from './hair/4x/hair-61.png';
import HAIR_62_URL from './hair/4x/hair-62.png';
import HAIR_63_URL from './hair/4x/hair-63.png';
import HAIR_64_URL from './hair/4x/hair-64.png';
import HAIR_65_URL from './hair/4x/hair-65.png';
import HAIR_66_URL from './hair/4x/hair-66.png';
import HAIR_67_URL from './hair/4x/hair-67.png';
import HAIR_68_URL from './hair/4x/hair-68.png';
import HAIR_69_URL from './hair/4x/hair-69.png';
import HAIR_70_URL from './hair/4x/hair-70.png';
import HAIR_71_URL from './hair/4x/hair-71.png';
import HAIR_72_URL from './hair/4x/hair-72.png';
import HAIR_73_URL from './hair/4x/hair-73.png';
import HAIR_74_URL from './hair/4x/hair-74.png';
import HAIR_75_URL from './hair/4x/hair-75.png';
import HAIR_76_URL from './hair/4x/hair-76.png';
import HAIR_77_URL from './hair/4x/hair-77.png';
import HAIR_78_URL from './hair/4x/hair-78.png';
import HAIR_79_URL from './hair/4x/hair-79.png';
import HAIR_80_URL from './hair/4x/hair-80.png';
import HAIR_81_URL from './hair/4x/hair-81.png';
import HAIR_82_URL from './hair/4x/hair-82.png';
import HAIR_83_URL from './hair/4x/hair-83.png';
import HAIR_84_URL from './hair/4x/hair-84.png';
import HAIR_85_URL from './hair/4x/hair-85.png';
import HAIR_86_URL from './hair/4x/hair-86.png';
import HAIR_87_URL from './hair/4x/hair-87.png';
import HAIR_88_URL from './hair/4x/hair-88.png';
import HAIR_89_URL from './hair/4x/hair-89.png';
import HAIR_90_URL from './hair/4x/hair-90.png';
import HAIR_91_URL from './hair/4x/hair-91.png';
import HAIR_92_URL from './hair/4x/hair-92.png';
import HAIR_93_URL from './hair/4x/hair-93.png';
import HAIR_94_URL from './hair/4x/hair-94.png';
import HAIR_95_URL from './hair/4x/hair-95.png';
import HAIR_96_URL from './hair/4x/hair-96.png';
import HAIR_97_URL from './hair/4x/hair-97.png';
import HAIR_98_URL from './hair/4x/hair-98.png';
import HAIR_99_URL from './hair/4x/hair-99.png';
import HAIR_100_URL from './hair/4x/hair-100.png';
import HAIR_101_URL from './hair/4x/hair-101.png';
import HAIR_102_URL from './hair/4x/hair-102.png';
import HAIR_103_URL from './hair/4x/hair-103.png';
import HAIR_104_URL from './hair/4x/hair-104.png';
import HAIR_105_URL from './hair/4x/hair-105.png';
import HAIR_106_URL from './hair/4x/hair-106.png';
import HAIR_107_URL from './hair/4x/hair-107.png';
import HAIR_108_URL from './hair/4x/hair-108.png';
import HAIR_109_URL from './hair/4x/hair-109.png';
import HAIR_110_URL from './hair/4x/hair-110.png';
import HAIR_111_URL from './hair/4x/hair-111.png';
import HAIR_112_URL from './hair/4x/hair-112.png';
import HAIR_113_URL from './hair/4x/hair-113.png';
import HAIR_114_URL from './hair/4x/hair-114.png';
import HAIR_115_URL from './hair/4x/hair-115.png';
import HAIR_116_URL from './hair/4x/hair-116.png';
import HAIR_117_URL from './hair/4x/hair-117.png';
import NEW_HAIR_1_URL from './hair/new/new-hair-1.png';
import HEAD_0_URL from './heads/4x/head-0.png';
import HEAD_1_URL from './heads/4x/head-1.png';
import HEAD_2_URL from './heads/4x/head-2.png';
import HEAD_3_URL from './heads/4x/head-3.png';
import HEAD_4_URL from './heads/4x/head-4.png';
import MOUTH_0_URL from './mouths/4x/mouth-0.png';
import MOUTH_1_URL from './mouths/4x/mouth-1.png';
import MOUTH_2_URL from './mouths/4x/mouth-2.png';
import MOUTH_3_URL from './mouths/4x/mouth-3.png';
import MOUTH_4_URL from './mouths/4x/mouth-4.png';
import MOUTH_5_URL from './mouths/4x/mouth-5.png';
import MOUTH_6_URL from './mouths/4x/mouth-6.png';
import MOUTH_7_URL from './mouths/4x/mouth-7.png';
import MOUTH_8_URL from './mouths/4x/mouth-8.png';
import MOUTH_9_URL from './mouths/4x/mouth-9.png';
import MOUTH_10_URL from './mouths/4x/mouth-10.png';
import MOUTH_11_URL from './mouths/4x/mouth-11.png';
import MOUTH_12_URL from './mouths/4x/mouth-12.png';
import MOUTH_13_URL from './mouths/4x/mouth-13.png';
import MOUTH_14_URL from './mouths/4x/mouth-14.png';
import MOUTH_15_URL from './mouths/4x/mouth-15.png';
import MOUTH_16_URL from './mouths/4x/mouth-16.png';
import MOUTH_17_URL from './mouths/4x/mouth-17.png';
import MOUTH_18_URL from './mouths/4x/mouth-18.png';
import MOUTH_19_URL from './mouths/4x/mouth-19.png';
import MOUTH_LIPSTICK_0_URL from './mouths/4x/mouth-lipstick-0.png';
import MOUTH_LIPSTICK_1_URL from './mouths/4x/mouth-lipstick-1.png';
import MOUTH_LIPSTICK_2_URL from './mouths/4x/mouth-lipstick-2.png';
import MOUTH_LIPSTICK_3_URL from './mouths/4x/mouth-lipstick-3.png';
import MOUTH_LIPSTICK_4_URL from './mouths/4x/mouth-lipstick-4.png';
import MOUTH_LIPSTICK_5_URL from './mouths/4x/mouth-lipstick-5.png';
import MOUTH_LIPSTICK_6_URL from './mouths/4x/mouth-lipstick-6.png';
import MOUTH_LIPSTICK_7_URL from './mouths/4x/mouth-lipstick-7.png';
import MOUTH_LIPSTICK_8_URL from './mouths/4x/mouth-lipstick-8.png';
import MOUTH_LIPSTICK_9_URL from './mouths/4x/mouth-lipstick-9.png';
import MOUTH_LIPSTICK_10_URL from './mouths/4x/mouth-lipstick-10.png';
import MOUTH_LIPSTICK_11_URL from './mouths/4x/mouth-lipstick-11.png';
import MOUTH_LIPSTICK_12_URL from './mouths/4x/mouth-lipstick-12.png';
import MOUTH_LIPSTICK_13_URL from './mouths/4x/mouth-lipstick-13.png';
import MOUTH_LIPSTICK_14_URL from './mouths/4x/mouth-lipstick-14.png';
import MOUTH_LIPSTICK_15_URL from './mouths/4x/mouth-lipstick-15.png';
import MOUTH_LIPSTICK_16_URL from './mouths/4x/mouth-lipstick-16.png';
import MOUTH_LIPSTICK_17_URL from './mouths/4x/mouth-lipstick-17.png';
import MOUTH_LIPSTICK_18_URL from './mouths/4x/mouth-lipstick-18.png';
import MOUTH_LIPSTICK_19_URL from './mouths/4x/mouth-lipstick-19.png';
import NOSE_0_URL from './noses/4x/nose-0.png';
import NOSE_1_URL from './noses/4x/nose-1.png';
import NOSE_2_URL from './noses/4x/nose-2.png';
import NOSE_3_URL from './noses/4x/nose-3.png';
import NOSE_4_URL from './noses/4x/nose-4.png';
import NOSE_5_URL from './noses/4x/nose-5.png';
import NOSE_6_URL from './noses/4x/nose-6.png';
import NOSE_7_URL from './noses/4x/nose-7.png';
import NOSE_8_URL from './noses/4x/nose-8.png';
import NOSE_9_URL from './noses/4x/nose-9.png';
import NOSE_10_URL from './noses/4x/nose-10.png';
import NOSE_11_URL from './noses/4x/nose-11.png';
import NOSE_12_URL from './noses/4x/nose-12.png';
import NOSE_13_URL from './noses/4x/nose-13.png';
import NOSE_14_URL from './noses/4x/nose-14.png';
import NOSE_15_URL from './noses/4x/nose-15.png';
import NOSE_16_URL from './noses/4x/nose-16.png';
import NOSE_17_URL from './noses/4x/nose-17.png';
import NOSE_18_URL from './noses/4x/nose-18.png';
import NOSE_19_URL from './noses/4x/nose-19.png';
import NOSE_20_URL from './noses/4x/nose-20.png';
import NOSE_21_URL from './noses/4x/nose-21.png';
import NOSE_22_URL from './noses/4x/nose-22.png';
import NOSE_23_URL from './noses/4x/nose-23.png';
import NOSE_24_URL from './noses/4x/nose-24.png';
import NOSE_25_URL from './noses/4x/nose-25.png';
import NOSE_26_URL from './noses/4x/nose-26.png';
import NOSE_27_URL from './noses/4x/nose-27.png';
import NOSE_28_URL from './noses/4x/nose-28.png';
import NOSE_29_URL from './noses/4x/nose-29.png';
import NOSE_30_URL from './noses/4x/nose-30.png';
import NOSE_31_URL from './noses/4x/nose-31.png';
import NOSE_32_URL from './noses/4x/nose-32.png';
import NOSE_33_URL from './noses/4x/nose-33.png';
import NOSE_34_URL from './noses/4x/nose-34.png';
import NOSE_35_URL from './noses/4x/nose-35.png';
import NOSE_36_URL from './noses/4x/nose-36.png';
import NOSE_37_URL from './noses/4x/nose-37.png';
import NOSE_38_URL from './noses/4x/nose-38.png';
import NOSE_39_URL from './noses/4x/nose-39.png';
import NOSE_40_URL from './noses/4x/nose-40.png';
import NOSE_41_URL from './noses/4x/nose-41.png';
import NOSE_42_URL from './noses/4x/nose-42.png';
import NOSE_43_URL from './noses/4x/nose-43.png';
import NOSE_44_URL from './noses/4x/nose-44.png';
import NOSE_45_URL from './noses/4x/nose-45.png';
import NOSE_46_URL from './noses/4x/nose-46.png';
import NOSE_47_URL from './noses/4x/nose-47.png';
import NOSE_48_URL from './noses/4x/nose-48.png';
import NOSE_49_URL from './noses/4x/nose-49.png';
import NOSE_50_URL from './noses/4x/nose-50.png';
import NOSE_51_URL from './noses/4x/nose-51.png';
import NOSE_52_URL from './noses/4x/nose-52.png';
import NOSE_53_URL from './noses/4x/nose-53.png';
import NOSE_54_URL from './noses/4x/nose-54.png';
const USE_NEW_AVATAR_PARTS = false;
function getUrl(oldImageUrl, newImageUrl) {
    return USE_NEW_AVATAR_PARTS ? newImageUrl : oldImageUrl;
}
export const AVATAR_ASSET_PATHS = {
    head: [HEAD_0_URL, HEAD_1_URL, HEAD_2_URL, HEAD_3_URL, HEAD_4_URL],
    eyes: [
        EYES_0_URL,
        EYES_1_URL,
        EYES_2_URL,
        EYES_3_URL,
        EYES_4_URL,
        EYES_5_URL,
        EYES_6_URL,
        EYES_7_URL,
        EYES_8_URL,
        EYES_9_URL,
        EYES_10_URL,
        EYES_11_URL,
        EYES_12_URL,
        EYES_13_URL,
        EYES_14_URL,
        EYES_15_URL,
        EYES_16_URL,
        EYES_17_URL,
        EYES_18_URL,
        EYES_19_URL,
        EYES_20_URL
    ],
    mouth: [
        MOUTH_0_URL,
        MOUTH_1_URL,
        MOUTH_2_URL,
        MOUTH_3_URL,
        MOUTH_4_URL,
        MOUTH_5_URL,
        MOUTH_6_URL,
        MOUTH_7_URL,
        MOUTH_8_URL,
        MOUTH_9_URL,
        MOUTH_10_URL,
        MOUTH_11_URL,
        MOUTH_12_URL,
        MOUTH_13_URL,
        MOUTH_14_URL,
        MOUTH_15_URL,
        MOUTH_16_URL,
        MOUTH_17_URL,
        MOUTH_18_URL,
        MOUTH_19_URL
    ],
    hair: [
        HAIR_0_URL,
        getUrl(HAIR_1_URL, NEW_HAIR_1_URL),
        HAIR_2_URL,
        HAIR_3_URL,
        HAIR_4_URL,
        HAIR_5_URL,
        HAIR_6_URL,
        HAIR_7_URL,
        HAIR_8_URL,
        HAIR_9_URL,
        HAIR_10_URL,
        HAIR_11_URL,
        HAIR_12_URL,
        HAIR_13_URL,
        HAIR_14_URL,
        HAIR_15_URL,
        HAIR_16_URL,
        HAIR_17_URL,
        HAIR_18_URL,
        HAIR_19_URL,
        HAIR_20_URL,
        HAIR_21_URL,
        HAIR_22_URL,
        HAIR_23_URL,
        HAIR_24_URL,
        HAIR_25_URL,
        HAIR_26_URL,
        HAIR_27_URL,
        HAIR_28_URL,
        HAIR_29_URL,
        HAIR_30_URL,
        HAIR_31_URL,
        HAIR_32_URL,
        HAIR_33_URL,
        HAIR_34_URL,
        HAIR_35_URL,
        HAIR_36_URL,
        HAIR_37_URL,
        HAIR_38_URL,
        HAIR_39_URL,
        HAIR_40_URL,
        HAIR_41_URL,
        HAIR_42_URL,
        HAIR_43_URL,
        HAIR_44_URL,
        HAIR_45_URL,
        HAIR_46_URL,
        HAIR_47_URL,
        HAIR_48_URL,
        HAIR_49_URL,
        HAIR_50_URL,
        HAIR_51_URL,
        HAIR_52_URL,
        HAIR_53_URL,
        HAIR_54_URL,
        HAIR_55_URL,
        HAIR_56_URL,
        HAIR_57_URL,
        HAIR_58_URL,
        HAIR_59_URL,
        HAIR_60_URL,
        HAIR_61_URL,
        HAIR_62_URL,
        HAIR_63_URL,
        HAIR_64_URL,
        HAIR_65_URL,
        HAIR_66_URL,
        HAIR_67_URL,
        HAIR_68_URL,
        HAIR_69_URL,
        HAIR_70_URL,
        HAIR_71_URL,
        HAIR_72_URL,
        HAIR_73_URL,
        HAIR_74_URL,
        HAIR_75_URL,
        HAIR_76_URL,
        HAIR_77_URL,
        HAIR_78_URL,
        HAIR_79_URL,
        HAIR_80_URL,
        HAIR_81_URL,
        HAIR_82_URL,
        HAIR_83_URL,
        HAIR_84_URL,
        HAIR_85_URL,
        HAIR_86_URL,
        HAIR_87_URL,
        HAIR_88_URL,
        HAIR_89_URL,
        HAIR_90_URL,
        HAIR_91_URL,
        HAIR_92_URL,
        HAIR_93_URL,
        HAIR_94_URL,
        HAIR_95_URL,
        HAIR_96_URL,
        HAIR_97_URL,
        HAIR_98_URL,
        HAIR_99_URL,
        HAIR_100_URL,
        HAIR_101_URL,
        HAIR_102_URL,
        HAIR_103_URL,
        HAIR_104_URL,
        HAIR_105_URL,
        HAIR_106_URL,
        HAIR_107_URL,
        HAIR_108_URL,
        HAIR_109_URL,
        HAIR_110_URL,
        HAIR_111_URL,
        HAIR_112_URL,
        HAIR_113_URL,
        HAIR_114_URL,
        HAIR_115_URL,
        HAIR_116_URL,
        HAIR_117_URL
    ],
    ears: [
        EARS_0_URL,
        EARS_1_URL,
        EARS_2_URL,
        EARS_3_URL,
        EARS_4_URL,
        EARS_5_URL,
        EARS_6_URL,
        EARS_7_URL,
        EARS_8_URL,
        EARS_9_URL,
        EARS_10_URL,
        EARS_11_URL,
        EARS_12_URL,
        EARS_13_URL,
        EARS_14_URL,
        EARS_15_URL,
        EARS_16_URL,
        EARS_17_URL
    ],
    eyebrows: [
        EYEBROWS_0_URL,
        EYEBROWS_1_URL,
        EYEBROWS_2_URL,
        EYEBROWS_3_URL,
        EYEBROWS_4_URL,
        EYEBROWS_5_URL,
        EYEBROWS_6_URL,
        EYEBROWS_7_URL,
        EYEBROWS_8_URL,
        EYEBROWS_9_URL,
        EYEBROWS_10_URL,
        EYEBROWS_11_URL,
        EYEBROWS_12_URL,
        EYEBROWS_13_URL,
        EYEBROWS_14_URL,
        EYEBROWS_15_URL,
        EYEBROWS_16_URL,
        EYEBROWS_17_URL,
        EYEBROWS_18_URL,
        EYEBROWS_19_URL,
        EYEBROWS_20_URL,
        EYEBROWS_21_URL,
        EYEBROWS_22_URL,
        EYEBROWS_23_URL,
        EYEBROWS_24_URL,
        EYEBROWS_25_URL,
        EYEBROWS_26_URL,
        EYEBROWS_27_URL,
        EYEBROWS_28_URL,
        EYEBROWS_29_URL,
        EYEBROWS_30_URL,
        EYEBROWS_31_URL,
        EYEBROWS_32_URL,
        EYEBROWS_33_URL,
        EYEBROWS_34_URL,
        EYEBROWS_35_URL,
        EYEBROWS_36_URL,
        EYEBROWS_37_URL,
        EYEBROWS_38_URL,
        EYEBROWS_39_URL,
        EYEBROWS_40_URL,
        EYEBROWS_41_URL,
        EYEBROWS_42_URL,
        EYEBROWS_43_URL,
        EYEBROWS_44_URL,
        EYEBROWS_45_URL,
        EYEBROWS_46_URL,
        EYEBROWS_47_URL
    ],
    nose: [
        NOSE_0_URL,
        NOSE_1_URL,
        NOSE_2_URL,
        NOSE_3_URL,
        NOSE_4_URL,
        NOSE_5_URL,
        NOSE_6_URL,
        NOSE_7_URL,
        NOSE_8_URL,
        NOSE_9_URL,
        NOSE_10_URL,
        NOSE_11_URL,
        NOSE_12_URL,
        NOSE_13_URL,
        NOSE_14_URL,
        NOSE_15_URL,
        NOSE_16_URL,
        NOSE_17_URL,
        NOSE_18_URL,
        NOSE_19_URL,
        NOSE_20_URL,
        NOSE_21_URL,
        NOSE_22_URL,
        NOSE_23_URL,
        NOSE_24_URL,
        NOSE_25_URL,
        NOSE_26_URL,
        NOSE_27_URL,
        NOSE_28_URL,
        NOSE_29_URL,
        NOSE_30_URL,
        NOSE_31_URL,
        NOSE_32_URL,
        NOSE_33_URL,
        NOSE_34_URL,
        NOSE_35_URL,
        NOSE_36_URL,
        NOSE_37_URL,
        NOSE_38_URL,
        NOSE_39_URL,
        NOSE_40_URL,
        NOSE_41_URL,
        NOSE_42_URL,
        NOSE_43_URL,
        NOSE_44_URL,
        NOSE_45_URL,
        NOSE_46_URL,
        NOSE_47_URL,
        NOSE_48_URL,
        NOSE_49_URL,
        NOSE_50_URL,
        NOSE_51_URL,
        NOSE_52_URL,
        NOSE_53_URL,
        NOSE_54_URL
    ],
    facialLines: [
        FACIAL_LINES_0_URL,
        FACIAL_LINES_1_URL,
        FACIAL_LINES_2_URL,
        FACIAL_LINES_3_URL,
        FACIAL_LINES_4_URL,
        FACIAL_LINES_5_URL,
        FACIAL_LINES_6_URL,
        FACIAL_LINES_7_URL,
        FACIAL_LINES_8_URL,
        FACIAL_LINES_9_URL,
        FACIAL_LINES_10_URL,
        FACIAL_LINES_11_URL,
        FACIAL_LINES_12_URL,
        FACIAL_LINES_13_URL,
        FACIAL_LINES_14_URL,
        FACIAL_LINES_15_URL,
        FACIAL_LINES_16_URL,
        FACIAL_LINES_17_URL,
        FACIAL_LINES_18_URL,
        FACIAL_LINES_19_URL,
        FACIAL_LINES_20_URL,
        FACIAL_LINES_21_URL,
        FACIAL_LINES_22_URL,
        FACIAL_LINES_23_URL,
        FACIAL_LINES_24_URL,
        FACIAL_LINES_25_URL,
        FACIAL_LINES_26_URL,
        FACIAL_LINES_27_URL,
        FACIAL_LINES_28_URL,
        FACIAL_LINES_29_URL,
        FACIAL_LINES_30_URL,
        FACIAL_LINES_31_URL,
        FACIAL_LINES_32_URL,
        FACIAL_LINES_33_URL,
        FACIAL_LINES_34_URL,
        FACIAL_LINES_35_URL,
        FACIAL_LINES_36_URL,
        FACIAL_LINES_37_URL,
        FACIAL_LINES_38_URL,
        FACIAL_LINES_39_URL,
        FACIAL_LINES_40_URL,
        FACIAL_LINES_41_URL,
        FACIAL_LINES_42_URL,
        FACIAL_LINES_43_URL,
        FACIAL_LINES_44_URL,
        FACIAL_LINES_45_URL,
        FACIAL_LINES_46_URL,
        FACIAL_LINES_47_URL,
        FACIAL_LINES_48_URL
    ],
    eyewear: [
        EYEWEAR_0_URL,
        EYEWEAR_1_URL,
        EYEWEAR_2_URL,
        EYEWEAR_3_URL,
        EYEWEAR_4_URL,
        EYEWEAR_5_URL,
        EYEWEAR_6_URL,
        EYEWEAR_7_URL,
        EYEWEAR_8_URL,
        EYEWEAR_9_URL,
        EYEWEAR_10_URL,
        EYEWEAR_11_URL,
        EYEWEAR_12_URL,
        EYEWEAR_13_URL,
        EYEWEAR_14_URL,
        EYEWEAR_15_URL,
        EYEWEAR_16_URL,
        EYEWEAR_17_URL,
        EYEWEAR_18_URL,
        EYEWEAR_19_URL
    ],
    facialHair: [
        FACIAL_HAIR_0_URL,
        FACIAL_HAIR_1_URL,
        FACIAL_HAIR_2_URL,
        FACIAL_HAIR_3_URL,
        FACIAL_HAIR_4_URL,
        FACIAL_HAIR_5_URL,
        FACIAL_HAIR_6_URL,
        FACIAL_HAIR_7_URL,
        FACIAL_HAIR_8_URL,
        FACIAL_HAIR_9_URL,
        FACIAL_HAIR_10_URL,
        FACIAL_HAIR_11_URL,
        FACIAL_HAIR_12_URL,
        FACIAL_HAIR_13_URL,
        FACIAL_HAIR_14_URL,
        FACIAL_HAIR_15_URL,
        FACIAL_HAIR_16_URL,
        FACIAL_HAIR_17_URL,
        FACIAL_HAIR_18_URL,
        FACIAL_HAIR_19_URL,
        FACIAL_HAIR_20_URL,
        FACIAL_HAIR_21_URL,
        FACIAL_HAIR_22_URL,
        FACIAL_HAIR_23_URL,
        FACIAL_HAIR_24_URL,
        FACIAL_HAIR_25_URL,
        FACIAL_HAIR_26_URL,
        FACIAL_HAIR_27_URL,
        FACIAL_HAIR_28_URL,
        FACIAL_HAIR_29_URL,
        FACIAL_HAIR_30_URL,
        FACIAL_HAIR_31_URL,
        FACIAL_HAIR_32_URL,
        FACIAL_HAIR_33_URL,
        FACIAL_HAIR_34_URL,
        FACIAL_HAIR_35_URL,
        FACIAL_HAIR_36_URL,
        FACIAL_HAIR_37_URL,
        FACIAL_HAIR_38_URL,
        FACIAL_HAIR_39_URL,
        FACIAL_HAIR_40_URL,
        FACIAL_HAIR_41_URL,
        FACIAL_HAIR_42_URL,
        FACIAL_HAIR_43_URL,
        FACIAL_HAIR_44_URL,
        FACIAL_HAIR_45_URL,
        FACIAL_HAIR_46_URL,
        FACIAL_HAIR_47_URL,
        FACIAL_HAIR_48_URL,
        FACIAL_HAIR_49_URL,
        FACIAL_HAIR_50_URL,
        FACIAL_HAIR_51_URL,
        FACIAL_HAIR_52_URL,
        FACIAL_HAIR_53_URL,
        FACIAL_HAIR_54_URL
    ],
    backHair: [
        BACK_HAIR_0_URL,
        BACK_HAIR_1_URL,
        BACK_HAIR_2_URL,
        BACK_HAIR_3_URL,
        BACK_HAIR_4_URL,
        BACK_HAIR_5_URL,
        BACK_HAIR_6_URL,
        BACK_HAIR_7_URL,
        BACK_HAIR_8_URL,
        BACK_HAIR_9_URL,
        BACK_HAIR_10_URL,
        BACK_HAIR_11_URL,
        BACK_HAIR_12_URL,
        BACK_HAIR_13_URL,
        BACK_HAIR_14_URL,
        BACK_HAIR_15_URL,
        BACK_HAIR_16_URL,
        BACK_HAIR_17_URL,
        BACK_HAIR_18_URL,
        BACK_HAIR_19_URL,
        BACK_HAIR_20_URL,
        BACK_HAIR_21_URL,
        BACK_HAIR_22_URL,
        BACK_HAIR_23_URL,
        BACK_HAIR_24_URL,
        BACK_HAIR_25_URL,
        BACK_HAIR_26_URL,
        BACK_HAIR_27_URL,
        BACK_HAIR_28_URL,
        BACK_HAIR_29_URL,
        BACK_HAIR_30_URL,
        BACK_HAIR_31_URL,
        BACK_HAIR_32_URL,
        BACK_HAIR_33_URL,
        BACK_HAIR_34_URL,
        BACK_HAIR_35_URL,
        BACK_HAIR_36_URL,
        BACK_HAIR_37_URL,
        BACK_HAIR_38_URL,
        BACK_HAIR_39_URL,
        BACK_HAIR_40_URL,
        BACK_HAIR_41_URL,
        BACK_HAIR_42_URL,
        BACK_HAIR_43_URL,
        BACK_HAIR_44_URL,
        BACK_HAIR_45_URL
    ]
};
export const AVATAR_MOUTH_LIPSTICK_ASSET_PATHS = [
    MOUTH_LIPSTICK_0_URL,
    MOUTH_LIPSTICK_1_URL,
    MOUTH_LIPSTICK_2_URL,
    MOUTH_LIPSTICK_3_URL,
    MOUTH_LIPSTICK_4_URL,
    MOUTH_LIPSTICK_5_URL,
    MOUTH_LIPSTICK_6_URL,
    MOUTH_LIPSTICK_7_URL,
    MOUTH_LIPSTICK_8_URL,
    MOUTH_LIPSTICK_9_URL,
    MOUTH_LIPSTICK_10_URL,
    MOUTH_LIPSTICK_11_URL,
    MOUTH_LIPSTICK_12_URL,
    MOUTH_LIPSTICK_13_URL,
    MOUTH_LIPSTICK_14_URL,
    MOUTH_LIPSTICK_15_URL,
    MOUTH_LIPSTICK_16_URL,
    MOUTH_LIPSTICK_17_URL,
    MOUTH_LIPSTICK_18_URL,
    MOUTH_LIPSTICK_19_URL
];
